var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SectionContainerPage",
    [
      _c("SectionActivityTypeList", {
        attrs: {
          xs12: "",
          activityTypeList: _vm.activityTypeList,
          assetStatusList: _vm.assetStatusList,
          shouldShowSearch: true,
          toolbarActions: [
            {
              text: "Activity Type",
              icon: "add",
              iconColor: "success",
              emitEvent: "onAddNewActivityTypeClicked",
            },
          ],
          isLoading: _vm.isLoading,
        },
        on: {
          onAddNewActivityTypeClicked: function ($event) {
            _vm.showDialogFormActivityTypeAdd = true
          },
          onEditActivityTypeClicked: (val) => [
            (_vm.activityTypeToEdit = val.activityTypeToEdit),
            (_vm.showDialogFormActivityTypeEdit = true),
          ],
        },
      }),
      _vm._v(" "),
      _c("DialogFormActivityTypeAdd", {
        attrs: {
          showDialog: _vm.showDialogFormActivityTypeAdd,
          assetStatusList: _vm.assetStatusList,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormActivityTypeAdd = false
          },
          onSubmitClicked: (val) => [
            _vm.onDialogFormActivityTypeAddSubmit(val),
          ],
        },
      }),
      _vm._v(" "),
      _c("DialogFormActivityTypeEdit", {
        attrs: {
          showDialog: _vm.showDialogFormActivityTypeEdit,
          activityTypeToEdit: _vm.activityTypeToEdit,
          assetStatusList: _vm.assetStatusList,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormActivityTypeEdit = false
          },
          onSubmitClicked: (val) => [
            _vm.onDialogFormActivityTypeEditSubmit(val),
          ],
        },
      }),
      _vm._v(" "),
      _c("DialogFormConfirmation", {
        attrs: {
          showDialog: _vm.confirmationDialogShow,
          title: _vm.confirmationDialogTitle,
          message: _vm.confirmationDialogMessage,
          submitButtonText: _vm.confirmationDialogSubmitButtonText,
          submitButtonIcon: _vm.confirmationDialogSubmitButtonIcon,
          submitButtonColor: _vm.confirmationDialogSubmitButtonColor,
          cancelButtonText: _vm.confirmationDialogCancelButtonText,
          showCancelButton: _vm.confirmationDialogShowCancelButton,
          isLoading: _vm.isLoading,
        },
        on: {
          onSubmitClicked: _vm.onConfirmationDialogSubmitClicked,
          onCancelClicked: _vm.onConfirmationDialogCancelClicked,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }